import {
  faCalendar,
  faChartLineUp,
  faCheckCircle,
  faClock,
  faDownload,
  faEuroSign,
  faFileContract,
  faFilePdf,
  faFileSignature,
  faUserHeadset
} from "@fortawesome/pro-regular-svg-icons";
import {
  faBell,
  faEnvelope,
  faHouse,
  faLock,
  faMapMarkerAlt,
  faPhone,
  faRightLeft,
  faSearch,
  faSignOutAlt,
  faTimes,
  faUser
} from "@fortawesome/pro-solid-svg-icons";

const icons = [
  faUser,
  faSearch,
  faEuroSign,
  faFileContract,
  faFileSignature,
  faTimes,
  faUserHeadset,
  faChartLineUp,
  faPhone,
  faEnvelope,
  faMapMarkerAlt,
  faClock,
  faCheckCircle,
  faDownload,
  faFilePdf,
  faLock,
  faBell,
  faCalendar,
  faSignOutAlt,
  faRightLeft,
  faHouse
];

const aliases = {
  user: "fas fa-user",
  search: "fas fa-search",
  calender: "far fa-calendar",

  dashboard: "fas fa-house",
  fundingContract: "far fa-file-contract",
  signFundingContract: "far fa-file-signature",
  interestPayment: "far fa-euro-sign",
  contact: "far fa-user-headset",

  phone: "fas fa-phone",
  email: "fas fa-envelope",
  address: "fas fa-map-marker-alt",
  security: "fas fa-lock",
  notifications: "fas fa-bell",

  waiting: "far fa-clock",
  done: "far fa-check-circle",

  download: "far fa-download",
  pdf: "far fa-file-pdf",

  messages: "fas fa-envelope",
  switchFunder: "fas fa-right-left",
  logout: "fas fa-sign-out-alt"
};

export default {
  aliases,
  icons
};
